var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_19842)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.061 41.4719L51.291 44.6719L78.961 94.5419C79.1239 94.8402 79.3451 95.1028 79.6113 95.3141C79.8776 95.5253 80.1835 95.681 80.511 95.7719C80.8421 95.8711 81.1898 95.9027 81.5333 95.8649C81.8769 95.8271 82.2094 95.7207 82.511 95.5519L83.741 94.8719C84.0372 94.7072 84.298 94.4857 84.5086 94.2201C84.7192 93.9545 84.8754 93.6501 84.9682 93.3241C85.0611 92.9982 85.0888 92.6571 85.0499 92.3204C85.0109 91.9837 84.9059 91.658 84.741 91.3619L57.031 41.4919L57.061 41.4719Z",
    fill: "#CCE7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8304 47.6018L52.9304 44.4418L66.9304 35.6818L62.8304 28.3718L48.0004 35.5618L38.4004 45.0218L39.8304 47.6018Z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0709 48.3718L55.1709 45.2118L69.1709 36.4618L65.0709 29.1018L50.2309 36.2918L40.6309 45.7518L42.0709 48.3718Z",
    fill: "#CCE7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0832 34.6078L89.6821 33.576C88.984 33.0618 88.0011 33.211 87.487 33.9092L65.3267 63.9997C64.8125 64.6979 64.9616 65.6807 65.6598 66.1949L67.0609 67.2267C67.7591 67.7408 68.7419 67.5917 69.2561 66.8935L91.4164 36.803C91.9305 36.1048 91.7814 35.122 91.0832 34.6078Z",
    fill: "#F89358"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1305 101.212C50.1171 99.911 45.4991 97.4011 41.6805 93.9019C36.2305 88.8019 34.2305 80.2219 34.2305 80.2219C34.2305 80.2219 43.8705 76.2219 48.9605 72.3919C58.2905 65.3719 61.2305 59.4919 61.2305 59.4919L73.9205 70.6319C71.4804 76.8778 68.3439 82.8288 64.5705 88.3719C61.0505 93.6719 55.1305 101.212 55.1305 101.212Z",
    fill: "#FFB762"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7309 90.4219L38.1309 89.4819C38.2309 89.4219 48.2309 82.4819 53.0709 77.7919C57.0254 74.0195 60.59 69.8585 63.7109 65.3719L64.6009 64.4419C61.351 69.3805 57.6012 73.9714 53.4109 78.1419C48.5709 82.9119 38.8309 90.3719 38.7309 90.4219Z",
    fill: "#F89358"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6805 93.9017L40.2305 92.4617C40.3305 92.3717 50.5405 84.2017 54.0705 80.3717C62.2305 71.6117 65.5305 66.3717 65.5605 66.2717L66.4505 66.7217C66.3305 66.9617 63.1105 72.3417 54.9605 81.2817C51.8305 84.7117 42.1405 93.5117 41.6805 93.9017Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4002 86.2817L35.4902 84.1517C35.5902 84.1017 45.4302 79.3617 49.7802 75.4717C58.3502 67.8117 61.5902 62.3017 61.6202 62.2517L62.0502 62.5017C62.0502 62.5017 59.1502 68.2617 50.5202 75.9817C46.1102 79.9117 36.4902 86.2317 36.4002 86.2817Z",
    fill: "#F89358"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8914 97.3719L45.1914 96.8619C45.2714 96.7719 51.5814 90.4619 57.0714 83.9319C61.3598 78.9032 65.2578 73.5543 68.7314 67.9319L68.2414 68.6219L68.5414 68.2319C68.6614 68.5119 64.4114 75.4519 57.5414 84.2319C52.4114 90.7619 45.9714 97.3719 45.8914 97.3719Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0105 101.532C56.0105 101.532 54.2905 101.082 53.7305 100.892C53.1705 100.702 50.5605 99.6417 50.5605 99.6417C54.6971 95.5273 58.6031 91.1874 62.2605 86.6417C66.4156 81.1432 69.9944 75.2321 72.9405 69.0017L74.2305 70.5317C71.8298 76.8881 68.713 82.9505 64.9405 88.6017C61.4705 93.8817 56.0705 101.462 56.0105 101.532Z",
    fill: "#F89358"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6901 58.3842L76.1838 69.0582C76.4307 69.2433 76.5945 69.5184 76.6395 69.8237C76.6845 70.129 76.607 70.4397 76.424 70.6882L73.9275 74.0781L57.5577 62.0224L60.0542 58.6325C60.2383 58.3827 60.514 58.2161 60.8208 58.1696C61.1276 58.123 61.4403 58.2002 61.6901 58.3842Z",
    fill: "#F89358"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0309 55.7318L55.1009 54.7318L48.2309 52.4518L47.1009 45.8818L44.8709 52.1618L37.7109 53.2118L44.4909 55.4318L45.6909 62.3718L48.0309 55.7318Z",
    fill: "#F89358"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6213 77.2018L96.7713 76.5918L92.7713 75.2718L92.0613 71.3718L90.7412 75.0718L86.5312 75.6918L90.5312 76.9918L91.2313 81.0618L92.6213 77.2018Z",
    fill: "#FFB762"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_19842",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_19842"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19842",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.abec611f601cc079173a588aa6e593d5.svg";
export { ForwardRef as ReactComponent };